import { Content } from '@radix-ui/react-tabs';
import { ComponentPropsWithoutRef } from 'react';
import { cn } from '@/shared/lib/cn';
import './tabs.scss';

type Props = ComponentPropsWithoutRef<typeof Content>;
export const TabsContent = ({ children, className, ...props }: Props) => {
    return (
        <Content className={cn('tabs__content', className)} {...props} data-testid="tabs-content">
            {children}
        </Content>
    );
};
